import React, { HTMLAttributes } from 'react';
import styled from '@emotion/styled';
import { ReactComponent as LogoSvg } from './assets/logo.svg';
import { ReactComponent as MoLogoSvg } from './assets/mologo.svg';
import { ReactComponent as SgLogoWhiteSvg } from './assets/sglogo.svg';
import { isMasterOnline, isSiteGiant } from '../../productLine';

export interface LogoProps extends HTMLAttributes<HTMLDivElement> {
  mode?: 'rect' | 'text' | 'white-text';
  src?: string;
  width?: number;
}

const LogoBox = styled.div<{ mode: LogoProps['mode'] }>`
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 58px;
  background-color: ${({ mode }) => (mode === 'rect' ? 'var(--fett-app-primary-color)' : '')};
  color: ${({ mode }) => (mode === 'rect' ? '#fff' : 'var(--fett-app-primary-color)')};
  > img {
    width: 60px;
    height: auto;
    vertical-align: middle;
  }
`;

const Logo = (props: LogoProps) => {
  const { mode = 'rect', src, width, style, ...otherProps } = props;

  if (src) {
    return (
      <LogoBox mode={mode} {...otherProps}>
        <img src={src} alt="logo" />
      </LogoBox>
    );
  }

  return (
    <LogoBox mode={mode} {...otherProps}>
      {isMasterOnline ? (
        <MoLogoSvg width={width} height={width} style={style} />
      ) : isSiteGiant ? (
        <SgLogoWhiteSvg width={width} height={width} style={style} />
      ) : (
        <LogoSvg width={width} height={width} style={style} />
      )}
    </LogoBox>
  );
};

export default React.memo(Logo);
